<template>
  <CopyLink label="Copy permalink" :variant="variant" @click="copy"/>
</template>

<script>
import { copyText } from '@/services/browser/copy'

export default {
  props: {
    day: String,
    nid: String,
    variant: String,
  },
  computed: {
    n_link () { 
      const { nid, day } = this
      return { name: 'notification', params: { day, nid } }
    },
  },
  methods: {
    copy () {
      // calculate full url
      const relUrl = this.$router.resolve(this.n_link).href
      const l = document.location
      const url = `${l.protocol}//${l.host}${relUrl}`
      // now request permissions to copy
      copyText(url, 'Link copied', this)
    }
  }
}
</script>